import history from '@/helpers/history';
import { DIRTY } from '@/store/actions/edit_ride/ride';
import { saveRide, clearRide } from '@/store/actions/edit_ride';

export const SET_CONFIRM = 'edit_ride/meta/SET_CONFIRM';
export const SHOW_SAVE_MODAL = 'edit_ride/meta/SHOW_SAVE_MODAL';

let confirmPromise = null;
let confirmResolver = null;
export const setConfirm = (value, reason) => (dispatch, getState) => {
    if (value) {
        if (!confirmPromise)
            confirmPromise = new Promise((resolve) => {
                confirmResolver = resolve;
            });

        dispatch({
            type: SET_CONFIRM,
            value
        });

        return confirmPromise;
    } else {
        const { confirm } = getState().edit_ride.present.meta;
        confirmResolver &&
            confirmResolver(
                (reason === 'confirm'
                    ? dispatch(saveRide())
                    : Promise.resolve()
                ).then((result) => {
                    switch (confirm) {
                        case 'logout': {
                            break;
                        }

                        case 'back': {
                            if (result !== 'cancel' && reason !== 'cancel') {
                                dispatch(clearRide());
                                history.back();
                            }
                            break;
                        }
                    }

                    return reason;
                })
            );

        confirmResolver = null;
        confirmPromise = null;

        dispatch({
            type: SET_CONFIRM,
            value
        });
    }
};

export const setDirty = () => (dispatch) => {
    dispatch({ type: DIRTY, value: true });
};

let savePromise = null;
let saveResolver = null;
export const showSaveModal = (value, reason) => (dispatch) => {
    if (value) {
        if (!savePromise)
            savePromise = new Promise((resolve) => {
                saveResolver = resolve;
            });

        dispatch({
            type: SHOW_SAVE_MODAL,
            value
        });

        return savePromise;
    } else {
        if (reason === 'save') dispatch(saveRide());
        saveResolver && saveResolver(reason);
        saveResolver = null;
        savePromise = null;

        dispatch({
            type: SHOW_SAVE_MODAL,
            value
        });
    }
};
